/* eslint-disable @dropbox/sign/isolate-folder */
import hsFetch from 'js/sign-components/common/hs-fetch';

export * from 'js/sign-components/common/hs-fetch';

export default hsFetch;
